import {
  ExtractedFindingDetail,
  MvrExtractedFinding,
} from 'src/lib/documentIntelligence'

// The incident booleans (CMV involved / Injuries / Fatalities) the read-model
// carries as structured fields, rendered as Yes/No detail lines in the hover
// alongside the other extracted fields. Null (AI extracted nothing) is omitted.
export const incidentFactDetails = (
  finding: MvrExtractedFinding
): ExtractedFindingDetail[] =>
  (
    [
      ['CMV involved', finding.cmvInvolved],
      ['Fatalities', finding.fatalities],
      ['Injuries', finding.injuries],
    ] as const
  )
    .filter(([, value]) => value != null)
    .map(([label, value]) => ({ label, value: value ? 'Yes' : 'No' }))
